<template>
    <div>
        <div class="modal-boddy">
            <div class="modal-text center">
                <div class="text-center">
                  <span>
                    Olá, fornecedor(a)! A empresa que você representa é enquadrada como ME, EPP, MEI ou equiparada, e deseja usufruir dos benefícios previstos na Lei Complementar nº 123/2006? Além disso, confirma que não se enquadra em nenhum dos impedimentos do art. 3º, §4º, dessa mesma Lei?
                  </span>
                </div>
            </div>
        </div>
        <div class="modal-actions__actions">
            <v-btn color="primary btn-nao" outline @click="escolherValor('N')">Não</v-btn>
            <v-btn color="primary btn-sim" outline @click="escolherValor('S')">Sim</v-btn>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'LicitacaoFornecedorTermosInfoEmpresa',
        props: {
            value: {
                required: true
            }
        },
        methods: {
            escolherValor(valorEscolhido) {
                this.value.isMeEppMei = valorEscolhido
                this.irProximoPasso()
            },
            irProximoPasso() {
                this.$emit('proximo')
            }
        }
    }
</script>